import type { SVGProps } from 'react';

export function IconLinkedin(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.8594 31.25H5.41016V13.7305H10.8594V31.25ZM8.16406 11.3281C6.40625 11.3281 5 9.92188 5 8.16406C5 7.34375 5.35156 6.52344 5.9375 5.9375C6.52344 5.35156 7.34375 5 8.16406 5C8.98438 5 9.80469 5.35156 10.3906 5.9375C10.9766 6.52344 11.3281 7.34375 11.3281 8.16406C11.3281 9.92188 9.92188 11.3281 8.16406 11.3281ZM31.25 31.25H25.8008V22.6953C25.8008 20.7031 25.8008 18.0664 22.9883 18.0664C20.1758 18.0664 19.707 20.293 19.707 22.5781V31.25H14.2578V13.7305H19.5312V16.1328H19.5898C20.293 14.7266 22.1094 13.2617 24.7461 13.2617C30.2539 13.2617 31.25 16.8945 31.25 21.6406V31.25Z"
                fill="currentColor"
            />
        </svg>
    );
}
